import React from 'react';
import styled from 'styled-components';
import PlanViewer from '@component/gridgio/workspace/plan-viewer';
import IconBlock from '@component/common/block/icon-block';
import * as color from '@constant/color';
import * as size from '@constant/size';
import type { ISourceData } from '@datatype/gridgio/api-type';
import { useTypedDispatch } from '@hook/common/useStore';
import { actions as modalActions } from '@store/slice/gridgio/modal-slice';

interface IProps {
  source: ISourceData;
  preview?: boolean;
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const ExpandButtonContainer = styled.div`
  position: absolute;
  bottom: calc(${size.MARGIN_1} / 2);
  right: calc(${size.MARGIN_1} / 2);
  z-index: 1;
`;

const PlanThumbnail: React.FC<IProps> = ({ source, preview = true }) => {
  const dispatch = useTypedDispatch();
  const handlePreview = () => {
    if (!source.sourceLink) return;
    dispatch(
      modalActions.showDialogModal({
        type: 'plan-preview',
        data: { url: source.sourceLink, type: source.contentType === 'application/pdf' ? 'pdf' : 'image' },
      }),
    );
  };

  return (
    <Wrapper>
      <PlanViewer
        drawing={{
          url: source.sourceLink ?? '',
          type: source.contentType === 'application/pdf' ? 'pdf' : 'image',
        }}
        page={1}
        rotation={0}
        area={{
          point: [
            { x: 0, y: 0 },
            { x: 1, y: 0 },
            { x: 1, y: 1 },
            { x: 0, y: 1 },
          ],
        }}
        width='100%'
        height='100%'
        shadow={false}
      />
      {preview && (
        <ExpandButtonContainer>
          <IconBlock
            icon='maximize'
            design={{
              box: {
                width: size.DESIGN_SYSTEM_BUTTON_SMALL_HEIGHT,
                height: size.DESIGN_SYSTEM_BUTTON_SMALL_HEIGHT,
                backgroundColor: color.WHITE_1,
                borderRadius: size.DESIGN_SYSTEM_BUTTON_BORDER_RADIUS,
                shadow: color.SURFACE_SHADOW,
                event: { cursor: 'pointer' },
              },
              icon: { size: 'tiny', kind: 'outlined', color: color.BLACK_2 },
            }}
            click={{ handler: handlePreview }}
          />
        </ExpandButtonContainer>
      )}
    </Wrapper>
  );
};
export default PlanThumbnail;
